import { render, staticRenderFns } from "./PlabAndRecord.vue?vue&type=template&id=05e76410&scoped=true"
import script from "./PlabAndRecord.vue?vue&type=script&lang=js"
export * from "./PlabAndRecord.vue?vue&type=script&lang=js"
import style0 from "./PlabAndRecord.vue?vue&type=style&index=0&id=05e76410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e76410",
  null
  
)

export default component.exports